<app-title title="Appointment" description="" backBtn="true" (backclick)="back()"></app-title>
@if (appointment$ | async; as appointment) {
  @if (appointment | isClientErrorMessage) {
    <app-error [error]="appointment" (retry)="load()"></app-error>
  } @else {
    {{ appointment.consult_status }}
    @if (appointment.consult_status) {
      <button class="joii-btn-primary mt-4 disabled:opacity-50" (click)="continue(appointment.doc_id)">
        Continue Consultation
      </button>
    } @else {
      <button
        class="joii-btn-primary mt-4 disabled:opacity-50"
        (click)="start(appointment.pet_id, appointment.user_id)"
      >
        Start Consultation
      </button>
    }
    <app-detailslist [config]="getConfig(appointment)"></app-detailslist>
  }
} @else {
  <app-loader></app-loader>
}
